@if (support(); as s) {
  <div class="clb-support-frame" aria-hidden="true"></div>
  <section class="clb-support-panel" role="status" aria-live="polite" data-testid="support-banner">
    <div class="clb-support-panel__text">
      <strong class="clb-support-panel__title">Colobbo support</strong>
      <span>
        Signed in as <strong data-testid="support-as">{{ s.asEmail }}</strong>
        by <span data-testid="support-by">{{ s.email }}</span>.
        @if (s.endsAt) {
          Ends at <span data-testid="support-ends">{{ endsAtText(s.endsAt) }}</span>.
        }
        Every change is recorded.
      </span>
    </div>
    <button type="button" class="clb-support-panel__end" data-testid="support-end" (click)="endSession()">End session</button>
  </section>
}
